import { IS_WHITE_LABEL } from '@/shared/environments';

import { DotsStepper } from './components/DotsStepper/DotsStepper';
import { useStepper } from './components/DotsStepper/useStepper';
import { EditorInfo } from './components/EditorInfo/EditorInfo';
import { FeaturesBlock } from './components/FeaturesBlock/FeaturesBlock';
import { ReviewsInfo } from './components/ReviewsInfo/ReviewsInfo';
import { SContainer, SInfoBlock, SInfoContentBlock, STitle } from './styled';

const INFOS = [
  {
    title: (
      <>
        Best features <br /> for high-quality result
      </>
    ),
    children: <FeaturesBlock />,
  },
  {
    title: (
      <>
        2 000 000+ users trust <br />
        our video translation AI
      </>
    ),
    children: <ReviewsInfo />,
  },
  {
    title: (
      <>
        Intelligent video
        <br /> translation at scale
      </>
    ),
    children: <EditorInfo />,
  },
];

export const InfoSection = () => {
  const { currentSlide, currentSlideIndex, slidesLength, setCurrentSlideIndex } = useStepper({
    slides: INFOS,
    timeout: 4000,
  });
  return (
    <SContainer>
      {!IS_WHITE_LABEL && (
        <>
          <SInfoBlock>
            <SInfoContentBlock gap={28}>
              <STitle variant="title-1-md">{currentSlide.title}</STitle>
              {currentSlide.children}
            </SInfoContentBlock>
          </SInfoBlock>
          <DotsStepper activeStep={currentSlideIndex} steps={slidesLength} onStepClick={setCurrentSlideIndex} />
        </>
      )}
    </SContainer>
  );
};
